export default "/images/ico-user.svg?9b574a24d7cc0b5d94ec799213e6c45a";